import React from 'react';
import moment from 'moment';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';

import {
  CardContainer,
  IconWrapper,
  TextWrapper,
  SectionTitle
} from './refundCard.style';
import { Icon } from '../../../common';

const statusPropertiesMap = {
  CANCELADO: {
    title: 'Pagamento estornado',
    icon: (
      <Icon
        name={'pajamasCheck'}
        fill={'white'}
        width={'18px'}
        height={'18px'}
      />
    ),
    colors: {
      backgroundColor: '#ff8787',
      border: '#ff4949'
    }
  },
  DEFAULT: {
    title: 'Estorno em processamento',
    icon: <HourglassEmptyIcon fill={'white'} />,
    colors: {
      backgroundColor: '#FCAD36',
      border: '#a96603'
    }
  }
};

const OrderDetailsRefundCard = ({ status }) => {
  const statusProperties =
    statusPropertiesMap[String(status).toUpperCase()] || statusPropertiesMap.DEFAULT;

  return (
    <div style={{ flex: '1' }}>
      <SectionTitle>Pagamento</SectionTitle>
      <CardContainer>
        <IconWrapper
          backgroundColor={statusProperties.colors.backgroundColor}
          borderColor={statusProperties.colors.borderColor}
        >
          {statusProperties.icon}
        </IconWrapper>
        <TextWrapper>
          <TextWrapper.Description>
            {moment(new Date()).format('DD/MM/YYYY')}
          </TextWrapper.Description>
          <TextWrapper.Title>{statusProperties.title}</TextWrapper.Title>
        </TextWrapper>
      </CardContainer>
    </div>
  );
};

export default OrderDetailsRefundCard;
